import { Component, OnInit, Inject } from '@angular/core';
import {Router} from "@angular/router"
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import { MatDialog} from '@angular/material/dialog';
import { environment } from '../../../environments/environment';
import { DlgTrabajandoComponent } from '../../components/dlg-trabajando/dlg-trabajando.component';
import { DlgErrorComponent } from '../../components/dlg-error/dlg-error.component';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-dlg-obras-sociales-plan',
  templateUrl: './dlg-obras-sociales-plan.component.html',
  styleUrls: ['./dlg-obras-sociales-plan.component.css']
})
export class DlgObrasSocialesPlanComponent implements OnInit {

  titulo=""
  nombre=""
  habilitado=true
  idActual=""

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private httpClient: HttpClient,
    @Inject(SESSION_STORAGE) private storage: StorageService,
    public thisDialogRef: MatDialogRef<DlgObrasSocialesPlanComponent>,
  ) { }

  ngOnInit(): void {
  }

  cerrarDialogo(dialogoActual) {
    dialogoActual.close();
  }

  cerrar(cadena) {
    this.thisDialogRef.close({mensaje: cadena, idPlan: this.idActual
      ,nombre: this.nombre
      ,habilitado: this.habilitado});
  }

  almacenar(){
    if (this.nombre==""){
      let dlgError = this.dialog.open(DlgErrorComponent, {
        width: '600px',
        disableClose:true
      });
      dlgError.componentInstance.titulo="Error al almacenar el plan de la obra social";
      dlgError.componentInstance.texto="Le falto indicar el nombre del plan de la obra social";
      return;
    }
    this.cerrar('almaceno');
  }
}
